<template>
  <Table
    stripe
    :showHeader=false
    border
    :columns="columns1"
    :data="multipleSelection"
    style="overflow-y: hidden;max-height: 522px;text-align:center"
  >
    <template
      slot-scope="{ row }"
      slot="type"
    >
      <Tag
        color="blue"
        v-if="row.type===0"
      >目录</Tag>
      <Tag
        color="green"
        v-if="row.type===1"
      >菜单</Tag>
      <Tag
        color="gold"
        v-if="row.type===2"
      >按钮</Tag>
    </template>

  </Table>

</template>

<script>
import expandRow from '../components/expand.vue';
export default {
  props: ['row'],
  data() {
    return {
      showDeletewin: false,  //显示删除提示
      showData: {
        list: [],          //列表容器
        pageNum: 1
      },
      multipleSelection: [],
      columns1: [           //表头
        { title: 'ID', key: 'menuId' },
        {  //添加的expand
          type: 'expand',
          width: 40,
          render: (h, params) => {
            return h(expandRow, {
              style: {
                padding: 0
              },
              props: {
                row: params.row
              }
            })
          }
        },

        {          title: '名称', key: 'name', ellipsis: true,
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }, params.row.name)
            ]);
          }
        },
        { title: '上级菜单', key: 'parentName' },
        { title: '图标', key: 'icon' },
        { title: '类型', key: 'type', slot: 'type' },
        { title: '排序号', key: 'orderNum' },
        { title: '菜单URL', key: 'url' },
        { title: '授权标识', key: 'perms' },
        {          title: '操作', key: 'action', width: 150, align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.editInfo(params.row.menuId)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: {
                  click: () => {
                    //  this.$emit('deleteInfo',params.row.menuId);
                    this.deleteInfo(params.row.menuId)
                  }
                }
              }, '删除')
            ])
          }
        }
      ]
    }
  },
   components: {
     expandRow
   },
  mounted() {

  },
  created() {  
    if (this.row.children == undefined) {
    } else {
      var object = this.row.children;
      this.multipleSelection.splice(0)
      object.forEach(r => {
        this.multipleSelection.push(r)
      })
    }

  
  },
  methods: {
     editInfo(id) {     
      this.$router.push({ path: '/menu/edit', query: { id: id } })
    },
    deleteInfo(id) {
      const that = this
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
          this.$Loading.start()
          // let tempfrom = [id]
          this.$axios.get('sys/menu/delete/' + id)
            .then(function (response) {
              if (response.data.success) {
                this.$Loading.finish()
            
                // this.$emit('getList');
               window.location.reload()
                // this.$router.push({ path: '/menu/list'})
                this.$Message.success(response.data.errMsg)
               
              } else {
                this.$Message.error(response.data.errMsg)
                this.$Loading.error()
              }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      });
    }

  }
}
</script>

<style lang="scss" scoped>
td.ivu-table-expanded-cell {
  padding: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/expand.vue